import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { Modal as AntModal } from "antd";
import { toast } from "react-toastify";
const DiscountApprovalList = (props) => {
  const { addForm, update } = props;
  const [data, setData] = useState([]);
  const [itemsPerPage] = useState(10);
  const { sendRequest: getUser } = useHttp();

  const { sendRequest: getDataList } = useHttp();
  const [allData, setAllData] = useState([]);

  const { sendRequest: deleteDiscount } = useHttp();

  const deleteData = (discountApprovalId) => {
    //console.log(discountApprovalId);
    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this discount detail?",
      onOk() {
        deleteDiscount(
          {
            url: `/api/discountApproval/?${discountApprovalId}`,
            method: "DELETE",
          },
          (res) => {
            //console.log(res);
            toast.success("Discount Deleted ");
            FillDetail();
          }
        );
      },
      onCancel() {},
    });
  };

  const FillDetail = () => {
    getDataList(
      {
        url: `/api/discountApproval/?useCase=Procurement&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        if (res) {
          setData(res);
          setAllData(res);
        }
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getDataList]);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSearch = (e) => {
      var filetrtext = e.target.value.trim().toLowerCase();
    //console.log(filetrtext);

    var filterdata = allData.filter(
      (item) =>
        item?.accountGroupName?.includes(filetrtext) ||
        item?.accountGroupcode?.includes(filetrtext) ||
        item?.accountHead?.includes(filetrtext) ||
        item?.accountSubGroupName?.includes(filetrtext) ||
        item?.accountSubGroupCode?.includes(filetrtext) ||
        item?.accountCode?.includes(filetrtext) ||
        item?.accountName?.includes(filetrtext)
    );

   setData(filterdata); 
                                
setCurrentPage(1);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-2 my-3"> &nbsp; &nbsp;Discount Approval Details </label>{" "}
          </div>
          <div className="col-3"> </div>
          <div className="col-3">
            <button
              type="button"
              className="btn  btn-primary mx-2 my-2"
              onClick={() => {
                addForm(true);
                props.update(false);
              }}
            >
              Add Discount Approval
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-9"> </div>
                  

                      <div className="col-3">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                          placeholder="Search..."
                        />{" "}<br/>
                      </div>
                    </div>
                    <div className="row">
                      <table className="table table-bordered text-center">
                        <thead>
                          <tr>
                            {/* <th>Discount Approval Id</th> */}
                            <th>Discount Approval Date</th>
                            <th>From Date</th>

                            <th>To Date</th>
                            <th>Discount Percentage</th>
                            <th>Procurement Officer </th>
                            <th>Edit</th>
                            <th>Delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr key={i}>
                                {/* <td>{x.discountApprovalId}</td> */}
                                <td>{x.discountApprovalDate}</td>
                                <td>{x.fromDate}</td>

                                <td>{x.toDate}</td>
                                <td>{x.discountPercentage}</td>
                                <td>{x.employeeName}</td>
                                <td>
                                  <button className="btn">
                                    {" "}
                                    <i className="fas fa-edit"></i>
                                  </button>
                                </td>
                                <td>
                                  <button
                                    className="btn"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      deleteData(x.discountApprovalId);
                                    }}
                                  >
                                    {" "}
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default DiscountApprovalList;
